import styles from './NewProgressionCard.module.css';

interface NewProgressionCardProps {
  onClick: () => void;
}

export const NewProgressionCard: React.FC<NewProgressionCardProps> = ({ onClick }) => {
  return (
    <button className={styles.card} onClick={onClick}>
      <div className={styles.plusCircle}>+</div>
      <span className={styles.label}>Begin a new page</span>
      <span className={styles.shortcut}>cmd N</span>
    </button>
  );
};
